/**
 * Login page component
 */

import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { useAuth0 } from '@auth0/auth0-react'
import { IconLogin } from '@tabler/icons-react'

export default function Login() {
  const { loginWithRedirect, isLoading } = useAuth0()

  const handleLogin = () => {
    loginWithRedirect({
      authorizationParams: {
        screen_hint: 'login',
      },
    })
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <Spinner className="h-12 w-12 mx-auto mb-4" />
          <p className="text-muted-foreground">Đang tải...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="max-w-md w-full bg-card border border-border rounded-lg shadow-lg p-8">
        <div className="flex flex-col items-center mb-6">
          <img
            src="/icons/favicon-96x96.png"
            alt="Gold Tracker Logo"
            className="w-16 h-16 mb-4"
            style={{ borderRadius: 12 }}
            width="64"
            height="64"
          />
          <h1 className="text-3xl font-bold text-foreground mb-2 text-center">Gold Tracker</h1>
        </div>
        <p className="text-muted-foreground text-center mb-8">
          Theo dõi và phân tích biến động tài sản vàng
        </p>

        <Button onClick={handleLogin} className="w-full min-h-[44px]" size="lg">
          <IconLogin className="h-5 w-5 mr-2" stroke={1.5} />
          Đăng nhập
        </Button>

        <p className="text-sm text-muted-foreground text-center mt-6">
          Vui lòng đăng nhập để truy cập ứng dụng
        </p>
      </div>
    </div>
  )
}
